module.exports = __webpack_public_path__ + "img/zixun-recommend-1.7f521d88.png";